// extracted by css-extract-rspack-plugin
export default {"root":"root-SKD8P1","muted":"muted-kEMh1l","tight":"tight-Y1c9JH"};